// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";

var Raw = {};

var query = GraphqlTag.gql(["fragment WordFlyersMenuFragment on AcademyMenuNode   {\n__typename  \nid  \ntitle  \n}\n"]);

function parse(value) {
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title
        };
}

function serialize(value) {
  var value$1 = value.title;
  var value$2 = value.id;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          id: value$2,
          title: value$1
        };
}

function verifyArgsAndParse(_WordFlyersMenuFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var WordFlyersMenuFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment WordFlyersActivityFragment on AcademyActivity   {\n__typename  \nid  \ntitle  \n}\n"]);

function parse$1(value) {
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title
        };
}

function serialize$1(value) {
  var value$1 = value.title;
  var value$2 = value.id;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          id: value$2,
          title: value$1
        };
}

function verifyArgsAndParse$1(_WordFlyersActivityFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var WordFlyersActivityFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

export {
  WordFlyersMenuFragment ,
  WordFlyersActivityFragment ,
}
/* query Not a pure module */
